const mediaSwiper = new Swiper('.media-only-slider', {
    // Optional parameters
    loop: false,
    slidesPerView: 1,
    autoplay: false,
    allowTouchMove: true, // Enable touch/swipe gestures
    navigation: {
        nextEl: '.media-only-slider .swiper-controls .next',
        prevEl: '.media-only-slider .swiper-controls .prev',
    },
    pagination: {
        el: '.media-only-slider .swiper-pagination',
        clickable: true,
    },
});